import * as React from 'react';

import cls from 'classnames';
import { FieldProps, getIn } from 'formik';

const styles = require('./IconCheckbox.scss');

interface Props extends FieldProps {
    label?: string;
    readonly: boolean | undefined;
    disabled?: boolean;
    hideErrors?: boolean;
}

class IconCheckbox extends React.Component<Props> {
    input: HTMLInputElement;

    constructor(props: Props) {
        super(props);
    }

    render() {
        const {
            field,
            form: { errors, touched },
            label,
            readonly,
            children,
            disabled,
            hideErrors,
            ...props
        } = this.props;

        return (
            <div className={cls(styles.className, { [styles.disabled]: disabled })} style={readonly ? { pointerEvents: 'none' } : {}}>
                <span className={styles.label}>
                    <span className={cls(styles.icon, { [styles.checked]: !!field.value })} onClick={() => !disabled && this.input.click()}>
                        {children}
                    </span>
                    <input
                        ref={(el: HTMLInputElement) => {
                            this.input = el;
                        }}
                        {...field}
                        {...props}
                        type='checkbox'
                        className={styles.input}
                    />
                    {label}
                </span>
                {!hideErrors && getIn(errors, field.name) && getIn(touched, field.name) && (
                    <div className={styles.error}>{getIn(errors, field.name)}</div>
                )}
            </div>
        );
    }
}

export default IconCheckbox;
